import { ICoordinateBounds } from "types/gps.types";

const coordinateBounds: ICoordinateBounds = { lat: [48.5, 51.1], lon: [12.1, 19.0] };

class GpsHelper {
    static isCoordinateWithinBounds(lat: number, lon: number, bounds: ICoordinateBounds = coordinateBounds): boolean {
        const [minLat, maxLat] = bounds.lat;
        const [minLon, maxLon] = bounds.lon;
        return lat >= minLat && lat <= maxLat && lon >= minLon && lon <= maxLon;
    }

    static isCoordinate(query: string): { result: boolean; lat?: number; lon?: number } {
        const regexGps = /^\s*([+-]?\d+(?:\.\d+)?)\s*[, ]\s*([+-]?\d+(?:\.\d+)?)\s*$/;
        const coordinate = query.match(regexGps);
        if (!coordinate) return { result: false };

        const lat = parseFloat(coordinate[1]);
        const lon = parseFloat(coordinate[2]);

        if (Number.isNaN(lat) || Number.isNaN(lon)) return { result: false };
        return { result: true, lat, lon };
    }
}

export default GpsHelper;
